import { render, staticRenderFns } from "./the-great-t-shirt-challenge.vue?vue&type=template&id=0839f12c&scoped=true&"
import script from "./the-great-t-shirt-challenge.vue?vue&type=script&lang=js&"
export * from "./the-great-t-shirt-challenge.vue?vue&type=script&lang=js&"
import style0 from "./the-great-t-shirt-challenge.vue?vue&type=style&index=0&id=0839f12c&prod&lang=css&"
import style1 from "./the-great-t-shirt-challenge.vue?vue&type=style&index=1&id=0839f12c&prod&lang=scss&scoped=true&"
import style2 from "./the-great-t-shirt-challenge.vue?vue&type=style&index=2&id=0839f12c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0839f12c",
  null
  
)

export default component.exports